/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/function-component-definition */
import React, { useState, useImperativeHandle } from 'react';
import { Modal as AntModal } from 'antd';
import Button from '../base/Button';
import styles from './index.module.scss';
import Modal from '../Modal';

export interface ConfirmModalRef {
  openModal: () => void;
  closeModal: () => void;
}

interface ConfirmModalProps extends React.ComponentProps<typeof AntModal> {
  title?: string;
  children: React.ReactNode;
  confirmText: string | (() => React.ReactNode);
  onClose?: () => void;
  onConfirm?: () => void | Promise<void>;
  disabled?: boolean;
  destroyOnClose?: boolean;
  buttonStyle?: React.CSSProperties;
}
const ConfirmModal: React.ForwardRefRenderFunction<ConfirmModalRef, ConfirmModalProps> = ({
  title = '',
  children,
  confirmText = '',
  onClose,
  onConfirm,
  disabled = false,
  destroyOnClose = false,
  buttonStyle,
  ...props
}, ref) => {
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    onClose?.();
    setOpen(false);
  };

  useImperativeHandle(ref, () => ({
    openModal: () => {
      setOpen(true);
    },
    closeModal: () => {
      setOpen(false);
    },
  }));

  return (
    <Modal
      {...props}
      wrapClassName={styles['confirm-modal-wrapper']}
      open={open}
      onCancel={handleClose}
      bodyClassName={styles['confirm-modal-body']}
      destroyOnClose={destroyOnClose}
    >
      {!!title && <div className={styles.title}>{title}</div>}
      <div className={styles['confirm-container']}>
        {children}
      </div>
      { typeof confirmText === 'function' ? confirmText?.() : <Button onClick={onConfirm} type="primary" buttonStyle={{ width: '100%', ...(buttonStyle || {}) }} disabled={disabled}>{confirmText}</Button>}
    </Modal>

  );
};
export default React.forwardRef(ConfirmModal);
